import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Slide,
  TextField,
  Theme,
  withStyles,
} from "@material-ui/core";
import { API } from "aws-amplify";
import { TransitionProps } from "@material-ui/core/transitions";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import { CRISPS_INSURANCE_ID, PCS_INSURANCE_ID } from "../../../../../../consts/Patterns";
import UpdateInsuranceResult from "./UpdateInsuranceResult";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface IUpdateInsuranceState {
  binNumber: string;
  cardHolderId: string;
  formSubmitted: boolean;
  groupNumber: string;
  insuranceId: string;
  message: string;
  open: boolean;
  pcn: string;
  personId: string;
  resultSuccessful: boolean;
  response: string;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class UpdateInsuranceSection extends React.Component<
  any,
  IUpdateInsuranceState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      binNumber: "456789",
      cardHolderId: "123456789",
      formSubmitted: false,
      groupNumber: "",
      insuranceId: "",
      message: "",
      open: false,
      pcn: "XPAY",
      personId: "",
      response: "",
      resultSuccessful: false,
    };

    this.handlePersonId = this.handlePersonId.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCardHolderId = this.handleCardHolderId.bind(this);
    this.handleBinNumber = this.handleBinNumber.bind(this);
    this.handlePcn = this.handlePcn.bind(this);
    this.handleGroupNumber = this.handleGroupNumber.bind(this);
    this.handleInsuranceId = this.handleInsuranceId.bind(this);
  }

  public render() {
    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="Person Id (Required)"
              variant="outlined"
              value={this.state.personId}
              onChange={this.handlePersonId}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="Insurance Id (Required)"
              variant="outlined"
              value={this.state.insuranceId}
              onChange={this.handleInsuranceId}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="RXPCN # (Required)"
              variant="outlined"
              value={this.state.pcn}
              onChange={this.handlePcn}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="MEMBER ID #"
              variant="outlined"
              value={this.state.cardHolderId}
              onChange={this.handleCardHolderId}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="RXBIN #"
              variant="outlined"
              value={this.state.binNumber}
              onChange={this.handleBinNumber}
            />
          </Grid>
          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="RX GROUP #"
              variant="outlined"
              value={this.state.groupNumber}
              onChange={this.handleGroupNumber}
            />
          </Grid>

          <Grid item xs>
            <Button
              variant="outlined"
              color="default"
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12}>
            {this.state.formSubmitted && <LoadingSpinner />}
            {this.state.resultSuccessful && (
              <UpdateInsuranceResult
                resultSuccessful={this.state.resultSuccessful}
                response={this.state.response}
              />
            )}
          </Grid>

          {this.state.message && (
            <Dialog
              open={this.state.open}
              TransitionComponent={TransitionConst}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              onClose={this.handleClose}
            >
              <DialogTitle id="alert-dialog-slide-title">
                {"Update Insurance Response"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {this.state.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      </Grid>
    );
  }

  public handleClose() {
    this.setState({ open: false });
  }

  public handlePersonId(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ personId: event.target.value });
  }

  public handleInsuranceId(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ insuranceId: event.target.value });
  }

  public handleCardHolderId(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ cardHolderId: event.target.value });
  }

  public handleBinNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ binNumber: event.target.value });
  }

  public handleGroupNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ groupNumber: event.target.value });
  }

  public handlePcn(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ pcn: event.target.value });
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.personId) {
      alert("Please enter the person id");
      formIsValid = false;
    } else if (
      !this.state.personId.match(
        "^amzn[1-9]+[0-9]*.([A-Za-z0-9]+.)+A[A-Z0-9]*$"
      )
    ) {
      alert("Please enter the valid personId.");
      formIsValid = false;
    }
    if (!this.state.insuranceId) {
      alert("Please enter the insurance Id");
      formIsValid = false;
    } else if (!this.state.insuranceId.toLowerCase().match(CRISPS_INSURANCE_ID) && !this.state.insuranceId.toLowerCase().match(PCS_INSURANCE_ID)) {
      alert("Please enter the valid insurance id.");
      formIsValid = false;
    }
    if (
      !this.state.cardHolderId &&
      !this.state.pcn &&
      !this.state.groupNumber &&
      !this.state.binNumber
    ) {
      alert(
        "Please enter any one of the field cardHolderId, pcn, groupNumber or binNumber to update"
      );
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleSubmit() {
    if (this.handleValidation()) {
      this.setState({ formSubmitted: true });
      this.setState({ resultSuccessful: false });

      const apiName = "ApaqPortalAPI";
      const path = "/pharmacy-customer/update-insurance";
      const config = {
        body: {
          binNumber: this.state.binNumber ? this.state.binNumber : "",
          cardHolderId: this.state.cardHolderId ? this.state.cardHolderId : "",
          groupNumber: this.state.groupNumber ? this.state.groupNumber : "",
          insuranceId: this.state.insuranceId,
          pcn: this.state.pcn,
          personId: this.state.personId,
        },
        headers: {},
      };

      API.post(apiName, path, config)
        .then((response) => {
          console.log(response);
          this.setState({ resultSuccessful: true });
          this.setState({
            response:
              'Update Insurance Successful - { Insurance Id: "' +
              response.response.insuranceId +
              '" }',
          });
          this.setState({ formSubmitted: false });
          this.setState({ personId: "" });
          this.setState({ binNumber: "" });
          this.setState({ groupNumber: "" });
          this.setState({ pcn: "" });
          this.setState({ cardHolderId: "" });
          this.setState({ insuranceId: "" });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ open: true });
          this.setState({ formSubmitted: false });
          this.setState({ message: error.response.data.message });
        });
    }
  }
}

export default withStyles(styles)(UpdateInsuranceSection);
